<template>
  <div class="edit-content">
    <w-navbar :icon="'iconchevron-left'" :nav_title="sectionTitle"
              @mobileLeftBtn="verifyData" :right_btn_html="rightBtnHtml" @mobileRightBtn="saveContent"/>
    <div v-show="!loadingShow || loadingOver">
      <div class="tinymce-editor" v-if="currentInfo">
        <editor v-model="suggest ? suggestInfo.highlight || currentInfo.description : currentInfo.description"
                :init="{...init, placeholder}">
        </editor>
      </div>
      <div class="bottom">
        <div class="suggest-wrapper flex-column-center" v-if="suggest">
          <suggest-card @handleClose="handleClose" :top="0"/>
        </div>
        <div class="content-course" :class="[{'flex-between row-reverse': !type}]">
          <div class="course-header flex-between" :class="{'only-tips': !type}">
            <div v-if="type === 'example' || type === 'verb'">
              <span class="course-text" :class="{'text-active': type === 'example'}"
                    v-if="examples && examples.length" @click="changeType('example')">填写案例</span>
              <span class="course-text" :class="{'text-active': type === 'verb'}" v-if="verbList && verbList.length"
                    @click="changeType('verb')">常用动词</span>
              <span class="course-text" v-if="!displayTips" @click="changeTipsStatus">小贴士</span>
            </div>
            <div class="flex-end tips" @click="changeTipsStatus" v-if="displayTips">
              <span class="iconfont iconwenhao"/>
              <span>简历小贴士</span>
            </div>
<!--            <div class="ai-cv-content">-->
<!--              AI 写简历-->
<!--            </div>-->
            <div class="flex-end tips" v-if="experienceShow">
              <w-tooltip v-if="experienceTooltip" class="w-tooltip" @handleClose="closeToolTip"></w-tooltip>
              <span class="iconfont iconbox"></span>
              <span @click="changeExperienceState">经历库</span>
            </div>
          </div>
          <div class="course-area" :class="{'no-area': !type}">
            <p class="indicate" v-if="type"
               :class="[{'indicate-verb': type === 'verb' && examples && examples.length}]"/>
            <div class="course-container">
              <div class="example-wrapper">
                <div class="flex-start example-select" v-show="type === 'example' && pickerShow">
                  <cube-select v-model="option" :options="pickerDataOptions" title=" " @change="changeOption"/>
                  <cube-select v-model="tag" :options="pickerDataTags" title=" " @change="changeTag"/>
                </div>
                <div class="example-container" v-show="type === 'example'">
                  <cube-scroll :data="[exampleIndex]">
                    <div class="example-content">
                      <template v-for="(item, index) in examples">
                        <p v-show="exampleIndex === index" :key="index" v-html="item.detail"/>
                      </template>
                    </div>
                  </cube-scroll>
                </div>
                <div class="example-footer flex-between">
                  <div class="use-example" @click="useExample" v-show="type === 'example' || type === 'edu'">
                    <span v-if="moduleType === 'edus'" class="iconfont iconGroup"/>
                    <span>{{ moduleType === 'edus' ? 'GPA计算器' : '使用案例' }}</span>
                  </div>
                  <div class="flex-start change-example" @click="nextStep"
                       v-show="type === 'example' && examples.length > 1">
                    <span class="iconfont iconcvs-gengxin"/>
                    <span class="count">换一个</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="course-container" v-show="type === 'verb'">
              <cube-select v-model="currentVerb" :options="pickerDataVerbs" title=" "/>
              <div class="verb-wrapper">
                <cube-scroll :data="[currentVerb]">
                  <div class="verb-list flex-start">
                    <span v-for="(item, index) in verbList" :key="index">{{ item[lang] }}</span>
                  </div>
                </cube-scroll>
              </div>
            </div>
          </div>
        </div>
      </div>
      <GPA :state="gpaState" @handleClose="gpaState = false"/>
      <cv-tips :state="cvTipShow" :tip-data="tipData" @handleClose="changeTipsStatus"/>
    </div>
    <w-loading v-if="loadingShow"/>
  </div>
</template>

<script>
	import tinymce from 'tinymce/tinymce'
	import Editor from '@tinymce/tinymce-vue'
	import 'tinymce/themes/silver'
	import 'tinymce/plugins/lists'// 列表插件
	import 'tinymce/plugins/link'
  import 'tinymce/plugins/paste'
	import WNavbar from '@/components/global/w-navbar'
	import TinymceEditor from '../text-editor/index'
	import WLoading from '@/components/global/w-loading'
	import cvTips from '../../cv-components/cv-tips'
	import GPA from '../../cv-components/GPA'
	import suggestCard from '../../cv-components/suggest-card'
	import { mapActions, mapState, mapMutations } from 'vuex'
	import { moduleMixin } from '../../../assets/js/mixin/cv'
	import { envMixin } from '@/assets/js/mixin/global'
	import { componentsMixin } from '@/assets/js/mixin/components'
	import { deleteRedundancy } from '@/assets/js/utils'
	import { addClass } from '@/assets/js/dom'
	import { eventMixin } from '../../../assets/js/mixin/global'
	import { userMixin } from '../../../assets/js/mixin/user'

	export default {
		mixins: [ moduleMixin, envMixin, componentsMixin, eventMixin, userMixin ],
		props: {
			baseUrl: {
				type: String,
				default: process.env.VUE_APP_ENV === 'local' ? '' : process.env.VUE_APP_OSS
			},
			experienceShow: {
				type: Boolean,
				default: false
			},
			experienceToolTip: {
				type: Boolean,
				default: false
			}
		},
		data () {
			return {
				text: '',
				type: 'example',
				exampleIndex: 0,
				currentVerb: '',
				// verbs: [],
				verbList: [],
				option: '',
				tag: '',
				example: {},
				loadingShow: true,
				description: '',
				gpaState: false,
				init: {
					language_url: `${ this.baseUrl }/tinymce/langs/zh_CN.js`,
					language: 'zh_CN',
					skin_url: `${ this.baseUrl }/tinymce/skins/ui/oxide`,
					content_css: `${ this.baseUrl }/tinymce/skins/content/default/content.css`,
					height: '',
					plugins: 'lists link paste',
					toolbar: 'undo redo bold italic bullist numlist outdent indent link removeformat',
					toolbar_sticky: true,
					branding: false,
					menubar: false,
					paste_remove_styles_if_webkit: true,
					paste_remove_styles: true,
          contextmenu: false,
          paste_as_text: true,
          paste_word_valid_elements: 'b,strong,em,li,ul,ol,p',
					// placeholder: ''
				},
			}
		},
		async mounted () {
      console.log(this.baseUrl,"=====================>aaaaaaaaaaaaaaaaaaa")
			this._getModuleContent()
			this.saveAccountToken()
			await this._changeWorkExample()
			setTimeout(() => {
				this._calcHeight()
			}, 0)
		},
		components: {
			WNavbar,
			TinymceEditor,
			WLoading,
			cvTips,
			GPA,
			suggestCard,
			Editor
		},
		watch: {
			// 当前选中的动词类别
			currentVerb (val) {
				if (this.verbList && this.verbList.length) {
					this.verbList = this.verbs.filter(item => item.subtitle === val)[0].values
				}
			}
		},
		computed: {
			...mapState('cv', [ 'cv', 'verbs', 'examples', 'example_options', 'example_tags', 'faqs', 'suggestInfo' ]),
			// 是否显示小贴士
			displayTips () {
				let { type } = this.$route.params
				return type !== 'personal_summary' && type !== 'skill_list'
			},
			// 动词的选择
			pickerDataVerbs () {
				return this.verbs.map(item => {
					return {
						text: item.subtitle,
						value: item.subtitle
					}
				})
			},
			// 案例库左侧的选择
			pickerDataOptions () {
				if (this.example_options) {
					return this.example_options.map(item => {
						if (this.workCn) {
							return { text: item.name, value: item.id }
						} else {
							return { text: item, value: item }
						}
					})
				}
			},
			// 案例库右侧的选择
			pickerDataTags () {
				if (this.example_tags) {
					return this.example_tags.map(item => {
						if (this.workCn) {
							return { text: item.name, value: item.id }
						} else {
							return { text: item, value: item }
						}
					})
				}
			},
			// 案例只有一条的时候不显示options
			pickerShow () {
				return (this.example_options || this.example_tags) && !!(this.example_options.length > 1 || this.example_tags.length > 1)
			},
			// 富文本编辑器的placeholder
			placeholder () {
				let { basic_info: { cv_type } } = this.cv
				switch (this.moduleType) {
					case 'personal_summary':
						if (cv_type.includes('grad')) {
							return '简短分条地总结与申请专业相关的经验、技能以及能力'
						} else {
							return '简短分条地总结与申请岗位相关的经验、技能以及能力'
						}
					case 'project_experience':
						if (cv_type.includes('programmer')) {
							return '简要说明参与开发的项目，附加超链接，展现自己的专业能力'
						} else {
							return '介绍在什么样项目中自己负责的内容，列出通过什么动作或技能达到了什么成果（最好是可量化的）'
						}
					case 'reasearch_experience':
						return '介绍研究项目如毕业论文，小组项目等，描述负责的具体内容，以及最终的项目成果，受到导师好评、获奖情况等'
					case 'skill_list':
						return '按照 “技能领域：编程语言（掌握程度）” 的格式罗列专业技能，如：Web开发：Python（熟练）'
					case 'custom':
						return '介绍在什么经历中，通过某些活动或技能，达到了什么样的成果'
					case 'edus':
						return '可以列出成绩、荣誉奖项、相关课程等'
					case 'works':
						return '简短介绍公司与自己负责的任务，分条罗列在什么项目中，通过某些动作或技能达到可量化的结果'
					case 'orgs':
						return '介绍在什么活动中自己负责的内容，列出通过什么动作获得了什么成果'
				}
			},
			// 中文工作模板
			workCn () {
				let lang = this.cv.basic_info.lang
				return this.moduleType === 'works' && lang === 'cn'
			}
		},
		methods: {
			...mapActions('cv', [ 'updateCustomInfo', 'updateModuleInfo', 'updateCvDetail' ]),
			...mapActions('cvExperience', [ 'getExperience' ]),
			...mapMutations('cv', [ 'changeAssistInfo', 'changeCurrentInfo' ]),
			// 更换经历库弹窗
			changeExperienceState () {
				this.$emit('changeExperienceState')
			},
			// 保存看是否进入过 text editor
			saveAccountToken () {
				this.$db.ls.set(`${ this.cvAccountToken }-editor`, true)
			},
			// 切换案例左侧
			changeOption () {
				if (this.workCn) {
					this._changeWorkExample({ profession_id: this.option, }, 'options')
				} else {
					this._searchExample()
				}
			},
			// 切换案例右侧
			changeTag () {
				if (this.workCn) {
					this._changeWorkExample({
						profession_id: this.option,
						ability_id: this.tag
					})
				} else {
					this._searchExample()
				}
			},
			// 关闭卡片
			handleClose () {
				this.changeSuggestState()
				setTimeout(() => {
					this._calcHeight()
				}, 220)
			},
			// 案例选择下一个
			nextStep () {
				if (this.exampleIndex + 1 === this.examples.length) {
					this.exampleIndex = 0
				} else {
					this.exampleIndex += 1
				}
			},
			// 使用案例
			useExample () {
				if (this.moduleType === 'edus') {
					this.gpaState = true
				} else {
					this.currentInfo.description += `<p>${ this.examples[this.exampleIndex].detail }</p>`
					// let el = document.querySelector('.tox-edit-area__iframe').contentWindow.document.querySelector('#tinymce')
					// setTimeout(() => {
					// 	let lastChild = el.lastChild
					// 	lastChild.scrollTo({ top: 180 })
					// }, 100)
				}
			},
			// 点击返回的时候校验是否更改
			verifyData () {
				let url = this.$db.ls.get('path') || `/cvs/${ this._token }/editor`
				let reqContent = this.$db.ls.get('req')
				let content = reqContent && reqContent.description && reqContent.description.replace(/\s+/g, '')
				let infoDesc = this.currentInfo.description && this.currentInfo.description.replace(/\s+/g, '')
				if (content !== infoDesc) {
					this.dialog = this.$createDialog({
						title: '提示',
						type: 'confirm',
						content: '还有内容尚未保存，确定离开吗?',
						onConfirm: async () => {
							if (this.info && this.$db.ls.get('req')) this.currentInfo.description = this.$db.ls.get('req').description
							// this.changeCurrentInfo(this.info)
							this.$router.back()
						}
					}).show()
				} else {
					this.$router.back()
				}
			},
			// 保存description
			async saveContent () {
				let description = tinyMCE.activeEditor.getContent()
				let { type } = this.$route.params
				if (!this.currentInfo.description) {
					this.showToast('完善经历信息，更容易获得青睐哦', 2000)
					return
				}
				let types = [ 'works', 'orgs', 'edus' ]
				let { highlightSave } = this.suggestInfo
				if (highlightSave || type === 'personal_summary' || type === 'skill_list') {
					if (types.includes(type)) {
						this.saveBaseExperience()
					} else {
						this.$emit('saveContent')
					}
				} else {
					this.currentInfo.description = description
					// this.changeCurrentInfo(this.info)
					this.$router.back()
				}
			},
			// 教育 工作 活动 text editor保存事件
			async saveBaseExperience () {
				let { type, token } = this.$route.params
				let { id, description } = this.currentInfo
        // description = description ? description.replace(/(?<= )class=".*?"/gi, '').replace(/div/gi, 'p') : null
				await this.updateModuleInfo({ id, payload: { description }, moduleName: type })
				await this.updateCvDetail({ token, payload: { operation_type: 'touch' } })
				
				this.$fn.redirect(
					`${window.location.origin}/cvs/${ token }/editor`,
					() => {
						this.$router.replace(`/cvs/${ token }/editor`)
					}
				)
			},
			// 切换案例和动词type
			changeType (type) {
				this.type = type
			},
			// 计算富文本编辑器的高度
			_calcHeight () {
				this.init.placeholder = this.placeholder
				let bodyHeight = this.isIos ? document.querySelector('.ios-content').offsetHeight : document.querySelector('.edit-content').offsetHeight
				let bottomHeight = document.querySelector('.bottom').offsetHeight
				let editor = document.querySelector('.tinymce-editor')
				editor.style.height = `${ bodyHeight - bottomHeight - 49 }px`
				setTimeout(() => {
					let toolBarEl = document.querySelector('.tox-editor-header')
					let editorEl = document.querySelector('.tox-editor-container')
					addClass(toolBarEl, 'tool-bar')
					addClass(editorEl, 'editor-container')
				}, 500)
			},
			// 处理底部数据
			_dealBottomData () {
				this.description = this.currentInfo.description
				this.option = this.example_options && this.example_options[0]
				this.tag = this.example_tags && this.example_tags[0]
				if (this.verbs && this.verbs.length) {
					this.type = 'verb'
					this.currentVerb = this.verbs[0].subtitle
					this.verbList = this.verbs[0].values
				}
				if (this.examples.length) {
					this.type = 'example'
				}
				this.loadingShow = false
			},
			// 改变中文works的案例
			async _changeWorkExample (payload, tag) {
				let { token } = this.$route.params
				if (this.workCn) {
					let res = await this.$api.cv.changeWorkExample(token, payload)
					if (payload && res.code === 1000) {
						let info = {
							example_tags: res.data.abilities,
							examples: res.data.examples
						}
						this.changeAssistInfo({ type: 'examples', info })
						if (tag === 'options') this.tag = res.data.abilities[0] && res.data.abilities[0].id
					} else if (res.code === 1000) {
						let info = {
							example_options: res.data.professions,
							example_tags: res.data.abilities,
							examples: res.data.examples
						}
						this.option = res.data.professions[0] && res.data.professions[0].id
						this.tag = res.data.abilities[0] && res.data.abilities[0].id
						this.changeAssistInfo({ type: 'examples', info })
						if (this.examples.length) this.type = 'example'
					}
					this.exampleIndex = 0
					this.loadingShow = false
					this.loadingOver = true
				}
			},
			// 初始化事件
			async _getModuleContent () {
				if (this.suggest) {
					let { info_id, type } = this.$route.params
					let { basic_info: { lang } } = this.cv
					this.getExperienceInfo(info_id, type, lang)
					tinymce.activeEditor.on('focus', () => {
						this.handleClose()
					})
				}
				this._dealBottomData()
			},
			// 搜索example
			async _searchExample () {
				let { basic_info: { lang, cv_type } } = this.cv
				let payload = {
					lang,
					cv_type,
					example_tag: this.tag,
					example_name: this.option,
				}
				let res = await this.$api.cv.searchExamples(payload)
				if (res.code === 1000) {
					this.exampleIndex = 0
					this.changeAssistInfo({ type: 'examples', info: res.data })
				}
			}
		}
	}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  .edit-content {
    width: 100vw;
    padding-top: 44px;
    height: 100vh;
    box-sizing: border-box;
    position: relative;
    .bottom {
      /*position: absolute;*/
      /*bottom: 0;*/
      .suggest-wrapper {
        .suggest-card {
          position: static;
          transform: translateX(0);
          left: 0;
        }
      }
      .row-reverse {
        flex-direction: row-reverse;
      }
      .content-course {
        padding: 16px 24px 38px;
        background-color: $color-light;
        .course-header {
          margin-bottom: 16px;
          .course-text {
            color: #9c9c9c;
            line-height: 20px;
            margin-right: 24px;
          }
          .text-active {
            color: $color-dark-gray;
            font-weight: 500;
          }
          .tips {
            position: relative;
            color: #4183ff;
            .w-tooltip {
              position: absolute;
              bottom: 40px;
              /deep/ .triangle {
                left: 160px;
              }
            }
            .iconfont {
              font-weight: 400;
              margin-right: 8px;
              font-size: 18px;
            }
          }
          .ai-cv-content {
            width: 80px;
            height: 24px;
            line-height: 24px;
            text-align: center;
            border-radius: 15px;
            background-color: #ff6644;
            color: #fff;
            font-size: 12px;
          }
        }
        .only-tips {
          margin-bottom: 0;
        }
        .course-area {
          position: relative;
          background-color: #f9f9f9;
          padding: 16px 20px;
          .indicate {
            position: absolute;
            top: -12px;
            left: px2rem(20px);
            width: 0;
            height: 0;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-bottom: 12px solid #f9f9f9;
          }
          .indicate-verb {
            left: px2rem(100px);
          }
          .no-content {
            display: none;
          }
          .course-container {
            .cube-select {
              flex: 1;
              display: flex;
              align-items: center;
              height: 38px;
              border: 1px solid #d9d9d9;
              color: $color-dark-gray;
              border-radius: 2px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              background-color: #f9f9f9;
              &:last-child {
                margin-left: 15px;
              }
              &::after {
                border: none;
              }
            }
            .cube-select_active::after {
              border: none;
            }
            .example-wrapper {
              .example-select {
                margin-bottom: 16px;
              }
              .example-container {
                height: 80px;
                margin-bottom: 10px;
                .example-content {
                  p {
                    color: $color-dark-gray;
                    line-height: 20px;
                  }
                }
              }
              .example-footer {
                .use-example {
                  color: #4183ff;
                  line-height: 20px;
                  .iconfont {
                    font-size: 14px;
                    margin-right: 8px;
                  }
                }
                .change-example {
                  .iconfont {
                    color: #4183FF;
                    margin-right: 4px;
                  }
                  .count {
                    margin-right: 8px;
                    color: #4183FF;
                    line-height: 20px;
                    letter-spacing: 1px;
                  }
                }
              }
            }
            .verb-wrapper {
              height: 126px;
              padding-top: 4px;
              .verb-list {
                flex-wrap: wrap;
                span {
                  width: 50%;
                  text-align: center;
                  line-height: 20px;
                  color: $color-dark-gray;
                  margin-top: 6px;
                }
              }
            }
          }
        }
        .no-area {
          padding: 0;
          background-color: $color-light;
        }
      }
    }
  }
  .tinymce-editor {
    /deep/ .tox-tinymce {
      border: none;
      box-sizing: border-box;
      .tool-bar {
        position: fixed;
        top: 44px;
      }
      .tool-bar-ios {
        position: fixed;
        top: 0;
      }
      .editor-container {
        padding-top: 40px;
      }
      .tox-statusbar {
        display: none;
      }
      .tox-toolbar__group {
        width: 100vw;
        display: flex;
        justify-content: space-between;
      }
    }
    /deep/ .mce-content-body {
      .check-highlight {
        color: $color-theme;
      }
    }
  }
  .ios-content {
    height: calc(100vh - 88px);
    .ios-content-course {
      padding-bottom: 0 !important;
    }
  }


</style>
